import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	fetchProcesses: ({ plantCd, urlSearchParams }) => {
		return client
			.get(`${BASE_URL}/process/v1/plants/${plantCd}/processes?${urlSearchParams}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchServiceKinds: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=SYSAREA`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchProcTypes: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=PROCTYPE`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchProcKinds: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=PROCKIND`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	// fetchOutputDevices: ({ plantCd }) => {
	// 	return client
	// 		.get(`${BASE_URL}/process/v1/plants/${plantCd}/outDevices`)
	// 		.then(response => (response && response.data) || null)
	// 		.catch(error => {
	// 			throw error;
	// 		});
	// },

	// fetchInputDevices: ({ plantCd }) => {
	// 	return client
	// 		.get(`${BASE_URL}/process/v1/plants/${plantCd}/inDevices`)
	// 		.then(response => (response && response.data) || null)
	// 		.catch(error => {
	// 			throw error;
	// 		});
	// },

	createProcess: ({ process }) => {
		const { plantCd, procId } = process;
		const uri = `${BASE_URL}/process/v1/status/1/plants/${plantCd}/processes/${procId}`;
		const encoded = encodeURI(uri);
		return client
			.post(encoded, process)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	updateProcess: ({ process }) => {
		const { plantCd, procId } = process;
		return client
			.post(`${BASE_URL}/process/v1/status/2/plants/${plantCd}/processes/${procId}`, process)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	deleteProcess: ({ plantCd, procId }) => {
		const uri = `${BASE_URL}/process/v1/status/3/plants/${plantCd}/processes/${procId}`;
		const encoded = encodeURI(uri);
		return client
			.post(encoded)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
